module.exports = __webpack_public_path__ + "static/scale-model-of-tuscaloosa-alabama-cbfb80883ab128f821a1d240ce430413.png";